import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        display: none;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Box, useWindowSize, Link } from "@miro-site/core";
import styled, { useTheme, css } from "styled-components";
import BottomLinks from "./BottomLinks";
var SecondaryNavigationWrapper = styled(Box).attrs(function(param) {
    var $offsetHeight = param.$offsetHeight, _$isFixed = param.$isFixed, $isFixed = _$isFixed === void 0 ? true : _$isFixed, _theme = param.theme, secondaryNavigation = _theme.header.secondaryNavigation;
    return {
        $styles: {
            opacity: $offsetHeight > 0 ? 1 : 0,
            transform: "translateY(".concat($offsetHeight, "px)"),
            width: "100%",
            height: "200vh",
            left: 0,
            bottom: "100%",
            boxShadow: secondaryNavigation.boxShadow,
            background: secondaryNavigation.background,
            transition: secondaryNavigation.animation.container,
            position: $isFixed ? "fixed" : "absolute",
            willChange: "transform",
            zIndex: 5
        }
    };
}).withConfig({
    componentId: "sc-8bf52616-0"
})(_templateObject());
var BottomLinksContainer = styled(BottomLinks).withConfig({
    componentId: "sc-8bf52616-1"
})(_templateObject2(), function(param) {
    var $offsetHeight = param.$offsetHeight;
    return $offsetHeight === 0 && css(_templateObject1(), Link);
});
var SecondaryNavigationContainer = function(props) {
    var activeNavigation = props.activeNavigation, activeNavigationRef = props.activeNavigationRef, bottomLinks = props.bottomLinks, isFixed = props.isFixed;
    var ref = useState(0), offsetHeight = ref[0], setOffsetHeight = ref[1];
    var height = useWindowSize().height;
    var theme = useTheme();
    useEffect(function() {
        var newOffsetHeight = activeNavigationRef.current ? activeNavigationRef.current.offsetHeight + theme.header.height + (bottomLinks.length > 0 ? theme.header.bottomLinks.height : 0) : 0;
        if (offsetHeight !== newOffsetHeight) {
            setOffsetHeight(newOffsetHeight);
        }
    }, [
        activeNavigation,
        height
    ]);
    return /*#__PURE__*/ _jsx(SecondaryNavigationWrapper, {
        $isFixed: isFixed,
        $offsetHeight: offsetHeight,
        children: bottomLinks.length > 0 && /*#__PURE__*/ _jsx(BottomLinksContainer, {
            bottomLinks: bottomLinks,
            $offsetHeight: offsetHeight
        })
    });
};
export default SecondaryNavigationContainer;
